import { render, staticRenderFns } from "./search_shop_config.vue?vue&type=template&id=87bf032a&scoped=true"
import script from "./search_shop_config.vue?vue&type=script&lang=js"
export * from "./search_shop_config.vue?vue&type=script&lang=js"
import style0 from "./search_shop_config.vue?vue&type=style&index=0&id=87bf032a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bf032a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bf032a')) {
      api.createRecord('87bf032a', component.options)
    } else {
      api.reload('87bf032a', component.options)
    }
    module.hot.accept("./search_shop_config.vue?vue&type=template&id=87bf032a&scoped=true", function () {
      api.rerender('87bf032a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-layout/components/rightConfig/search_shop_config.vue"
export default component.exports